<div class="webclient-healthcheck-dialog">
  <div class="dialog-header">
    <h1 mat-dialog-title class="main-title">
      {{ 'common.dialog.webClientHealthCheckDialog.title' | translate }}
    </h1>
  </div>

  <mat-dialog-content>
    <div class="dialog-content">
      <div class="content-description">
        <div
          [innerHTML]="
            'common.dialog.webClientHealthCheckDialog.text' | translate
          "
        ></div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="actions">
      <qa-button
        matDialogClose
        label="common.dialog.webClientHealthCheckDialog.button.close"
      ></qa-button>
      <qa-button
        [isRaisedButton]="true"
        label="common.dialog.webClientHealthCheckDialog.button.runCheckAgain"
        (click)="dialogRef.close(true)"
      ></qa-button>
    </div>
  </mat-dialog-actions>
</div>
